export const ONBOARDING_TOTAL_STEPS = 22;

export const ONBOARDING_ACTIONS = [
  "show_payment",
  "show_chickytutor",
  "show_whatsapp",
  "complete",
] as const;

export type OnboardingAction = (typeof ONBOARDING_ACTIONS)[number] | null;

export interface OnboardingChatMessage {
  role: "user" | "assistant";
  content: string;
  quick_replies?: string[];
  action?: OnboardingAction;
  step?: number;
}

export interface OnboardingAgentResponse {
  message: string;
  quick_replies: string[];
  action: OnboardingAction;
  step: number;
  extracted_data: Record<string, string>;
}

export interface GenerateOnboardingReplyInput {
  history: OnboardingChatMessage[];
  userMessage: string;
  currentStep?: number;
  collectedData?: Record<string, string>;
}
